// extracted by mini-css-extract-plugin
export default {"roster":"RosterView_roster__D7ClT","footer":"RosterView_footer__LtOgd","rosterButton":"RosterView_rosterButton__zQb4H"};